import React, { FC, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { IMG, WHATSAPP_LINK, CONTACT } from '../data/constants';
import { PRODUCTS } from '../data/products';
import { SERVICE_PLANS, SOFTWARE_LIST, BRANCHES } from '../data/siteData';
import { PageHero, CtaBanner } from '../components/SharedComponents';

/* ═══════════════════════════ COMPANY ═══════════════════════════ */
export const Company: FC = () => (
  <>
    <PageHero breadcrumbs={[{label:'Home',link:'/'},{label:'Company Profile'}]} title="About DevBhoomi Labels" subtitle="Your trusted partner for barcode and identification solutions across India."/>
    <section style={{background:'#fff'}}>
      <div className="container">
        <div className="about-grid">
          <div className="about-img-block">
            <img className="about-img-main" src={IMG.officeImg} alt=""/>
            <div className="about-badge"><span>500+</span>Clients Served</div>
          </div>
          <div className="about-content">
            <span className="section-tag">Who We Are</span>
            <h2 className="section-title">DevBhoomi Labels</h2>
            <p><strong style={{color:'var(--primary)'}}>DevBhoomi Labels</strong> is a leading provider of barcode labels, thermal transfer ribbons, barcode printers, scanners and complete retail POS solutions in India.</p>
            <p>Based in Dehradun, Uttarakhand, we serve businesses across India. We are authorized partners of <strong style={{color:'var(--primary)'}}>Zebra Technologies, Honeywell and TSC</strong>, ensuring genuine products with full warranty and support.</p>
            <ul className="check-list">
              <li>Authorized dealer for Zebra, Honeywell &amp; TSC</li>
              <li>10+ years of specialized barcode expertise</li>
              <li>In-house AMC &amp; technical support team</li>
              <li>Pan-India shipping &amp; delivery</li>
              <li>Custom label design and printing services</li>
            </ul>
            <Link to="/contact" className="btn btn-primary">Contact Us Today →</Link>
          </div>
        </div>
      </div>
    </section>
    <section style={{background:'var(--light)'}}>
      <div className="container">
        <span className="section-tag">Our Purpose</span><h2 className="section-title">Mission &amp; Vision</h2>
        <div className="mv-grid">
          <div className="mv-card mission"><h3>🎯 Our Mission</h3><p>To provide high-quality, reliable and cost-effective barcode and label solutions that help businesses improve efficiency, accuracy and productivity — backed by exceptional after-sales support.</p></div>
          <div className="mv-card vision"><h3>🔭 Our Vision</h3><p>To become India's most trusted and comprehensive barcode solutions company, empowering businesses across all sectors with cutting-edge identification technology and world-class service.</p></div>
        </div>
      </div>
    </section>
    <section style={{background:'#fff'}}>
      <div className="container">
        <span className="section-tag">Our Values</span><h2 className="section-title">What We Stand For</h2>
        <div className="val-grid">
          {[{img:IMG.quality,t:'✅ Quality First',d:'We only offer products that meet strict quality standards, ensuring longevity and performance.'},{img:IMG.customer,t:'🤝 Customer Focus',d:'Every solution is tailored to the specific needs and budget of our clients.'},{img:IMG.quickSupp,t:'⚡ Quick Support',d:'Downtime costs money. We prioritize rapid response for all support requests.'}].map(v=>(
            <div key={v.t} className="val-card"><img className="val-card-img" src={v.img} alt=""/><h4>{v.t}</h4><p>{v.d}</p></div>
          ))}
        </div>
      </div>
    </section>
    <div className="stats-strip"><div className="container"><div className="stats-grid">
      {[['500+','Satisfied Clients','Across Uttarakhand & India'],['10+','Years Experience',''],['7','Product Lines',''],['Pan','India Reach','All states covered']].map(([n,l,s])=>(
        <div key={l} className="stat-item"><div className="stat-num">{n}</div><div className="stat-lbl">{l}</div>{s&&<p className="stat-sub">{s}</p>}</div>
      ))}
    </div></div></div>
    <section style={{background:'var(--light)'}}>
      <div className="container">
        <span className="section-tag">Authorized Partners</span><h2 className="section-title">Brand Partners We Trust</h2>
        <div className="partner-grid">
          {[{img:IMG.printers,n:'Zebra Technologies',s:'Printers, Scanners & RFID'},{img:IMG.scanners,n:'Honeywell',s:'Scanners & Mobile Computers'},{img:IMG.ttrRibbons,n:'TSC Printers',s:'Desktop & Industrial Printers'},{img:IMG.barcodeLabels,n:'Datalogic',s:'Barcode Scanners & Readers'}].map(p=>(
            <div key={p.n} className="partner-card"><img className="partner-card-img" src={p.img} alt=""/><div className="partner-card-body"><h4>{p.n}</h4><p>{p.s}</p></div></div>
          ))}
        </div>
      </div>
    </section>
    <CtaBanner image={IMG.ctaOffice} title="Want to Know More?" subtitle="Visit our office or get in touch for a free consultation."
      primaryBtnText="Contact Us" primaryBtnLink="/contact" secondaryBtnText="Find Our Branches" secondaryBtnLink="/branches"/>
  </>
);

/* ═══════════════════════════ PRODUCTS LISTING ═══════════════════════════ */
export const Products: FC = () => (
  <>
    <PageHero breadcrumbs={[{label:'Home',link:'/'},{label:'Barcode Solutions'}]} title="Barcode Solutions" subtitle="Complete range of barcode labels, printers, scanners, ribbons and retail POS systems."/>
    <div className="prod-filter"><div className="container"><div className="filter-list">
      <span className="filter-btn active">All Products</span>
      {PRODUCTS.map(p=><Link key={p.id} to={p.path} className="filter-btn">{p.title}</Link>)}
    </div></div></div>
    <section style={{background:'var(--light)'}}><div className="container">
      <div className="section-head-row"><div><span className="section-tag">Our Products</span><h2 className="section-title">All Product Categories</h2></div></div>
      <div className="grid-4">
        {PRODUCTS.map(p=>(
          <Link key={p.id} to={p.path} className="prod-card">
            <div className="prod-img-wrap"><img className="prod-img" src={p.image} alt=""/><span className={`prod-badge b-${p.badgeColor}`}>{p.badge}</span></div>
            <div className="prod-body"><h3>{p.title}</h3><p>{p.description}</p><div className="prod-foot"><span className="pcat">{p.category}</span><span className="parrow">→</span></div></div>
          </Link>
        ))}
        <Link to="/contact" className="prod-card cta-dark-card"><h3>Need Custom Labels?</h3><p>Any size, material or quantity.</p><span className="btn btn-primary btn-sm">Get Quote →</span></Link>
      </div>
    </div></section>
    <CtaBanner image={IMG.ctaLabels} title="Need Custom Labels or Bulk Pricing?" subtitle="Contact us for custom sizes, materials and competitive bulk pricing."
      primaryBtnText="Get Custom Quote →" primaryBtnLink="/contact"/>
  </>
);

/* ═══════════════════════════ SERVICES ═══════════════════════════ */
export const Services: FC = () => (
  <>
    <PageHero breadcrumbs={[{label:'Home',link:'/'},{label:'Services'}]} title="Our Services" subtitle="Comprehensive repair, maintenance and technical support for all barcode equipment."/>
    <section id="amc" style={{background:'#fff'}}><div className="container">
      <div className="svc-split">
        <div className="svc-img-block"><img src={IMG.amc} alt=""/></div>
        <div className="svc-content">
          <span className="svc-badge">Annual Maintenance Contract</span>
          <h2>Repair &amp; Maintenance (AMC)</h2>
          <p>Keep your barcode printers and scanners in perfect working condition with our Annual Maintenance Contract. Scheduled preventive maintenance and priority repair services throughout the year.</p>
          <ul className="check-list">
            <li>Scheduled preventive maintenance visits (quarterly/half-yearly)</li>
            <li>Priority on-site repair service within 24–48 hours</li>
            <li>Genuine spare parts at discounted rates</li>
            <li>All brands — Zebra, Honeywell, TSC, Datalogic</li>
            <li>Head cleaning, calibration and firmware updates</li>
            <li>Dedicated AMC helpdesk support number</li>
          </ul>
          <Link to="/contact" className="btn btn-primary">Enquire for AMC →</Link>
        </div>
      </div>
    </div></section>
    <section style={{background:'var(--light)'}}><div className="container">
      <span className="section-tag">AMC Plans</span><h2 className="section-title">Choose Your Coverage Plan</h2>
      <p className="section-sub">Flexible AMC plans designed for every business size and requirement.</p>
      <div className="plan-grid">
        {SERVICE_PLANS.map(plan=>(
          <div key={plan.title} className={`plan-card${plan.popular?' pop':''}`}>
            {plan.popular&&<div className="pop-badge">⭐ Most Popular</div>}
            <img className="plan-card-img" src={plan.image} alt=""/>
            <div className="plan-body">
              <h3>{plan.title}</h3><p className="plan-desc">{plan.description}</p>
              <ul className="plan-feat">{plan.features.map(f=><li key={f}><span className="ck">✓</span>{f}</li>)}</ul>
              <Link to="/contact" className="btn btn-primary btn-block">Get Quote</Link>
            </div>
          </div>
        ))}
      </div>
    </div></section>
    <section id="support" style={{background:'#fff'}}><div className="container">
      <div className="svc-split rev">
        <div className="svc-img-block"><img src={IMG.support} alt=""/></div>
        <div className="svc-content">
          <span className="svc-badge">Technical Support</span>
          <h2>Expert Technical Support Services</h2>
          <p>Our certified technical team provides fast and effective remote and on-site support for all barcode hardware, software, label design and complete POS setups.</p>
          <ul className="check-list">
            <li>Remote desktop support for software and driver issues</li>
            <li>Barcode label design and ZPL/EPL programming</li>
            <li>Printer setup, configuration and calibration</li>
            <li>Integration with ERP, billing and inventory software</li>
            <li>POS system setup and staff training</li>
            <li>Network-connected printer and scanner support</li>
          </ul>
          <Link to="/contact" className="btn btn-primary">Request Support →</Link>
        </div>
      </div>
    </div></section>
    <section style={{background:'var(--light)'}}><div className="container">
      <span className="section-tag">How It Works</span><h2 className="section-title">Our Support Process</h2>
      <div className="steps-grid">
        {[['1','Contact Us','Call, WhatsApp or email us with your issue.'],['2','Assessment','Our technician diagnoses remotely or on-site.'],['3','Resolution','We fix the issue using genuine parts and proven methods.'],['4','Follow-Up','We confirm everything is working and provide a service report.']].map(([n,h,p])=>(
          <div key={n} className="step-card"><div className="step-num">{n}</div><h4>{h}</h4><p>{p}</p></div>
        ))}
      </div>
    </div></section>
    <CtaBanner image={IMG.ctaAMC} title="Equipment Not Working? Call Us Now!" subtitle="Mon–Sat 9:30 AM – 6:30 PM for urgent repair requests."
      primaryBtnText="Contact Us →" primaryBtnLink="/contact" secondaryBtnText="💬 WhatsApp" secondaryBtnLink={WHATSAPP_LINK} secondaryIsExternal/>
  </>
);

/* ═══════════════════════════ SOFTWARE ═══════════════════════════ */
export const Software: FC = () => (
  <>
    <PageHero breadcrumbs={[{label:'Home',link:'/'},{label:'Software'}]} title="Software Solutions" subtitle="Label design, barcode printing and retail POS software for every business need."/>
    <section style={{background:'var(--light)'}}><div className="container">
      <span className="section-tag">Our Software</span><h2 className="section-title">Barcode &amp; Label Software</h2>
      <p className="section-sub">We supply and support industry-leading label design software and retail POS solutions. Full installation, training and ongoing support provided.</p>
      <div className="sw-grid">
        {SOFTWARE_LIST.map(sw=>(
          <div key={sw.title} className="sw-card">
            <img className="sw-card-img" src={sw.image} alt=""/>
            <div className="sw-body">
              <span className="sw-badge">{sw.badge}</span>
              <h3>{sw.title}</h3><p>{sw.description}</p>
              <ul>{sw.points.map(pt=><li key={pt}>{pt}</li>)}</ul>
              <Link to="/contact" className="btn btn-primary">{sw.ctaText}</Link>
            </div>
          </div>
        ))}
      </div>
    </div></section>
    <CtaBanner image={IMG.ctaSoftware} title="Need Software Installation or Training?" subtitle="Full installation, configuration and staff training for all software solutions."
      primaryBtnText="Contact Us →" primaryBtnLink="/contact"/>
  </>
);

/* ═══════════════════════════ BRANCHES ═══════════════════════════ */
export const Branches: FC = () => (
  <>
    <PageHero breadcrumbs={[{label:'Home',link:'/'},{label:'Our Branches'}]} title="Our Branch Locations" subtitle="Find us across Uttarakhand — always nearby to serve you better."/>
    <section style={{background:'var(--light)'}}><div className="container">
      <span className="section-tag">Find Us</span><h2 className="section-title">Visit a Branch Near You</h2>
      <p className="section-sub" style={{marginBottom:40}}>Visit your nearest DevBhoomi Labels branch for product demos, purchases, service and technical support.</p>
      <div className="branch-grid">
        {BRANCHES.map(b=>(
          <div key={b.name} className="branch-card">
            <img className="branch-card-img" src={b.image} alt=""/>
            <div className="branch-header"><h3>{b.name}</h3>{b.isHQ&&<span className="hq-badge">HQ</span>}</div>
            <div className="branch-body">
              <div className="brow"><span className="blbl">📍 Address</span><span className="bval">{b.address}</span></div>
              {b.phone.map((ph,i)=><div key={i} className="brow"><span className="blbl">📞 Phone {i>0?i+1:''}</span><span className="bval"><a href={`tel:${ph}`}>{ph}</a></span></div>)}
              <div className="brow"><span className="blbl">💬 WhatsApp</span><span className="bval"><a href={`https://wa.me/${b.whatsapp}`} target="_blank" rel="noreferrer">+91 {b.whatsapp.slice(2)}</a></span></div>
              <div className="brow"><span className="blbl">📧 Email</span><span className="bval"><a href={`mailto:${b.email}`}>{b.email}</a></span></div>
              <div className="brow"><span className="blbl">🕐 Hours</span><span className="bval">{b.hours}</span></div>
              <a href={CONTACT.mapLink} target="_blank" rel="noreferrer" className="map-btn">📍 View on Google Maps</a>
            </div>
          </div>
        ))}
      </div>
    </div></section>
    <CtaBanner image={IMG.ctaBranches} title="Can't Visit? We Deliver Pan-India!" subtitle="Order by phone, WhatsApp or email — we ship across India."
      primaryBtnText="Order Now →" primaryBtnLink="/contact" secondaryBtnText="💬 WhatsApp" secondaryBtnLink={WHATSAPP_LINK} secondaryIsExternal/>
  </>
);

/* ═══════════════════════════ CONTACT ═══════════════════════════ */
export const Contact: FC = () => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    alert('Thank you for your enquiry! We will contact you within a few hours.');
  };

  return (
    <>
      <PageHero breadcrumbs={[{label:'Home',link:'/'},{label:'Contact Us'}]} title="Get In Touch" subtitle="We're here to help. Reach out for quotes, support or any enquiry."/>
      <section style={{background:'var(--light)'}}><div className="container">
        <div className="contact-grid">
          <div>
            <img className="contact-side-img" src={IMG.contactImg} alt=""/>
            <p className="contact-info-title">Contact Information</p>
            {[
              {cls:'i-red',  icon:'📍',h:'Head Office',     body:<p>{CONTACT.address}</p>},
              {cls:'i-blue', icon:'📞',h:'Phone Numbers',   body:<p><a href={`tel:${CONTACT.phone1}`}>{CONTACT.phone1}</a><br/><a href={`tel:${CONTACT.phone2}`}>{CONTACT.phone2}</a></p>},
              {cls:'i-green',icon:'📧',h:'Email Us',        body:<p><a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></p>},
              {cls:'i-orange',icon:'🕐',h:'Business Hours', body:<p>Mon – Sat: 9:30 AM – 6:30 PM<br/>Sunday: Closed</p>},
            ].map(c=>(
              <div key={c.h} className="info-card">
                <div className={`info-icon ${c.cls}`}>{c.icon}</div>
                <div><h4>{c.h}</h4>{c.body}</div>
              </div>
            ))}
            <div className="wa-box">
              <div><p>🟢 Quick WhatsApp Enquiry</p><p className="wa-box-sub">Get a response within minutes</p></div>
              <a href={WHATSAPP_LINK} className="wa-btn" target="_blank" rel="noreferrer">Chat Now →</a>
            </div>
          </div>
          <div className="form-card">
            <h3>Send Us a Message</h3>
            <p className="form-subh">Fill in the form and we'll get back to you within a few hours.</p>
            <form onSubmit={handleSubmit} noValidate>
              <div className="form-row-2">
                <div className="form-group"><label>Your Name *</label><input type="text" placeholder="Full Name" required/></div>
                <div className="form-group"><label>Phone Number *</label><input type="tel" placeholder="+91 XXXXX XXXXX" required/></div>
              </div>
              <div className="form-group"><label>Email Address</label><input type="email" placeholder="your@email.com"/></div>
              <div className="form-group"><label>Company / Business</label><input type="text" placeholder="Company Name (Optional)"/></div>
              <div className="form-group"><label>Enquiry Type *</label>
                <select required defaultValue="">
                  <option value="" disabled>Select Enquiry Type</option>
                  {['Barcode Labels','Thermal Transfer Ribbons','Barcode Printers','Barcode Scanners','Jewellery Labels','Taffeta Labels','Retail POS / Billing','Software','AMC / Repair Service','Technical Support','Custom Label Printing','Other'].map(o=><option key={o} value={o}>{o}</option>)}
                </select>
              </div>
              <div className="form-group"><label>Message *</label><textarea placeholder="Describe your requirement, quantity needed, or any questions..." required/></div>
              <button type="submit" className="btn-submit">Send Enquiry →</button>
            </form>
          </div>
        </div>
      </div></section>
    </>
  );
};
